import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import { unsetModal } from '../../actions/modal-actions'
import ComponentStateModal from './index.js'
import { clearInlineComponents } from '../../actions/harness-actions'
import {
  getDtcCodesFromHighlightedDtcs,
  getHistoryForSelectedModalComponent,
} from '../../selectors'
import { getElementName } from '../../helpers/element'
import { logComponentProblem } from '../../thunks/component'

const mapStateToProps = (state, ownProps) => {
  const stateToProps = {
    isOpen: state.modalState.isOpen,
    vehicleTestResultId: state.componentState.vehicleTestResultId,
    makeModelId: state.componentState.makeModelId,
    vin: state.componentState.vin,
    component: state.componentState.selectedElement,
    graphEdges: state.componentState.graphData.edges,
    historyForComponent: getHistoryForSelectedModalComponent(state),
    dtcs: getDtcCodesFromHighlightedDtcs(state),
    identifier: state.modalState?.component?.id,
    title: getElementName(state.componentState.selectedElement),
    stationId: state.modalState?.component?.assembly_station?.[0] ?? null,
    placeHolder: (
      <FormattedMessage id="tracer.logFailure.typePlaceholderComponent" />
    ),
  }

  if (state.modalState?.component?.category === 'not_electrical') {
    return {
      ...stateToProps,
      selectedComponent: state.modalState.not_electrical,
      faults: state.loggingState.faults.not_electrical,
      componentType: 'not_electrical',
    }
  } else {
    return {
      ...stateToProps,
      selectedComponent: state.modalState.component,
      faults: state.loggingState.faults.component,
      componentType: 'component',
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClose: () => {
      dispatch(clearInlineComponents())
      dispatch(unsetModal())
    },
    _onSubmit: (options) => {
      return dispatch(logComponentProblem(options))
    },
  }
}
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps, // optional
    ...dispatchProps, // optional
    onSubmit: (args) => {
      return dispatchProps._onSubmit({
        ...args,
        vehicleTestResultId: stateProps.vehicleTestResultId,
        makeModelId: stateProps.makeModelId,
        vin: stateProps.vin,
        dtcs: stateProps.dtcs,
        componentId: stateProps.component.id,
        stationId: stateProps.stationId,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ComponentStateModal)
